import { combineReducers } from 'redux'
import AutocompleteAvisoReducer from './autocompleteAviso/reducer'
import HealthStatusReducer from './healthStatus/reducer'

const bumiReducer = combineReducers({
  autocompleteAviso: AutocompleteAvisoReducer,
  healthStatusService: HealthStatusReducer,
})

export default bumiReducer
